export const colors = {
  primary: {
    navy: '#0A2647',
    petrol: '#213448',
  },
  background: {
    offWhite: '#F9FAFB',
  },
  text: {
    primary: '#111827',
    muted: '#6B7280',
  },
  accent: {
    gold: '#C9B37E',
  },
  status: {
    success: '#4A7C59',
    warning: '#C89B3C',
    error: '#C44536',
  },
};
